var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7342 3.38101C23.7342 2.56464 23.0032 1.9028 22.1016 1.9028H19.3407V0.603044C19.3407 0.270071 19.0424 0 18.6747 0H17.2361C16.8698 0 16.5693 0.270071 16.5693 0.603044V1.90348H7.40168V0.603044C7.40168 0.270071 7.10339 0 6.73563 0H5.39296C5.0252 0 4.72691 0.270071 4.72691 0.603044V1.90348H1.77425C0.872593 1.90348 0.141602 2.56533 0.141602 3.38169V8.64909H1.00172V20.1008C1.00172 20.9411 1.75311 21.6207 2.68044 21.6207H21.1017C22.0298 21.6207 22.7804 20.9411 22.7804 20.1008V8.64841H23.7372L23.7342 3.38101ZM20.1049 17.5922C20.1049 18.4325 19.3543 19.1121 18.4262 19.1121H5.45035C4.52302 19.1121 3.77164 18.4325 3.77164 17.5922V8.64841H20.1042V17.5922H20.1049Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73846 10.2908H6.06445V12.7994H8.73846V10.2908Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3224 10.2908H10.6484V12.7994H13.3224V10.2908Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9072 10.2908H15.2324V12.7994H17.9072V10.2908Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73846 14.7014H6.06445V17.2093H8.73846V14.7014Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3224 14.7014H10.6484V17.2093H13.3224V14.7014Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9072 14.7014H15.2324V17.2093H17.9072V14.7014Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.537a886078b13a805bd0f5c47d3dead3.svg";
export { ForwardRef as ReactComponent };